import { render, staticRenderFns } from "./SetStatusBox.vue?vue&type=template&id=44916a68"
import script from "./SetStatusBox.vue?vue&type=script&lang=js"
export * from "./SetStatusBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports